import { Outlet } from 'react-router-dom';

export const PATHS_WITHOUT_TOP_NAV = [];

export function AuthenticatedRoutesWrapper() {
    return (
        <>
            <Outlet />
        </>
    );
}
